import adminApiClient from '../../api/base/adminApiClient'

export interface Review {
  id: number
  user_id: number
  place_id: number
  review_category_id: number | null
  review_text: string | null // 한줄평 (nullable)
  visit_date: string | null
  internal_score: string | null
  score: string | null
  photos: any[] | null
  /** true: 공개, false: 나만보기 */
  is_public: boolean
  created_at: string
  updated_at: string
  user: {
    id: number
    username: string
    nickname: string
    profile_image: string | null
  } | null
  place: {
    id: number
    name: string
    address: string | null
  } | null
}

export interface GetReviewsResponse {
  data: Review[]
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export interface GetReviewsParams {
  page?: number
  per_page?: number
  search?: string
  /** 공개 범위로 거르기. 없으면 전부 */
  visibility?: 'public' | 'private'
}

/** reviews.photos 배열의 한 항목 */
export interface ReviewPhoto {
  id?: string
  preview: string
  description?: string
}

export const adminReviewApi = {
  getReviews: async (
    params?: GetReviewsParams
  ): Promise<GetReviewsResponse> => {
    const response = await adminApiClient.get<GetReviewsResponse>(
      '/admin/reviews',
      {
        params,
      }
    )
    return response.data
  },

  /**
   * 사진 한 장을 다른 이미지로 교체한다.
   *
   * photos 컬럼만 바뀐다 — 점수·알림·비교 히스토리는 그대로다.
   * 원본 파일은 지우지 않으므로 잘못 바꿔도 되돌릴 수 있다.
   */
  replacePhoto: async (
    reviewId: number,
    index: number,
    dataUrl: string
  ): Promise<ReviewPhoto[]> => {
    const response = await adminApiClient.put<{ photos: ReviewPhoto[] }>(
      `/admin/reviews/${reviewId}/photos/${index}`,
      { photo: dataUrl }
    )
    return response.data.photos
  },

  /**
   * 공개 ↔ 나만보기를 바꾼다.
   * is_public 만 바뀐다 — 점수·순위·사진·작성일은 그대로다.
   */
  updateReviewVisibility: async (
    reviewId: number,
    isPublic: boolean
  ): Promise<{ id: number; is_public: boolean }> => {
    const response = await adminApiClient.patch<{ id: number; is_public: boolean }>(
      `/admin/reviews/${reviewId}/visibility`,
      { is_public: isPublic }
    )
    return response.data
  },

  /** 사진 한 장을 목록에서 뺀다 (S3 파일은 남는다) */
  deletePhoto: async (
    reviewId: number,
    index: number
  ): Promise<ReviewPhoto[]> => {
    const response = await adminApiClient.delete<{ photos: ReviewPhoto[] }>(
      `/admin/reviews/${reviewId}/photos/${index}`
    )
    return response.data.photos
  },
}
